import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef } from "react";
import { Arrow } from "@vfit/ui/icons";
import { ButtonContainer, ButtonSmall, ButtonDefault, ArrowButton } from "./buttonSlide.style";
var ButtonSlide = /*#__PURE__*/ forwardRef(function(param, ref) {
    var name = param.name, label = param.label, small = param.small, animated = param.animated, rotation = param.rotation, buttonColor = param.buttonColor, hoverColor = param.hoverColor, hoverTextColor = param.hoverTextColor, clickColor = param.clickColor, clickTextColor = param.clickTextColor, labelColor = param.labelColor, iconColor = param.iconColor, borderColor = param.borderColor, smallSize = param.smallSize, arrowWidth = param.arrowWidth, arrowHeigth = param.arrowHeigth, disabled = param.disabled, disabledButtonColor = param.disabledButtonColor, disabledBorderColor = param.disabledBorderColor, disabledTextColor = param.disabledTextColor, onClick = param.onClick;
    var smallButton = function() {
        return /*#__PURE__*/ _jsx(ButtonSmall, {
            "aria-label": label || "",
            size: smallSize,
            buttonColor: buttonColor,
            onClick: onClick,
            hoverColor: hoverColor,
            hoverTextColor: hoverTextColor,
            clickTextColor: clickTextColor,
            clickColor: clickColor,
            borderColor: borderColor,
            "data-name": name,
            children: /*#__PURE__*/ _jsx(ArrowButton, {
                rotation: rotation || 0,
                color: iconColor || "#262626",
                arrowWidth: arrowWidth,
                arrowHeigth: arrowHeigth,
                children: /*#__PURE__*/ _jsx(Arrow, {})
            })
        });
    };
    var defaultButton = function() {
        return /*#__PURE__*/ _jsx(ButtonDefault, {
            "aria-label": label || "",
            buttonColor: buttonColor,
            hoverColor: hoverColor,
            hoverTextColor: hoverTextColor,
            clickColor: clickColor,
            clickTextColor: clickTextColor,
            labelColor: labelColor,
            borderColor: borderColor,
            disabled: disabled,
            disabledButtonColor: disabledButtonColor,
            disabledBorderColor: disabledBorderColor,
            disabledTextColor: disabledTextColor,
            onClick: onClick,
            "data-name": name,
            children: /*#__PURE__*/ _jsx("span", {
                children: label
            })
        });
    };
    return /*#__PURE__*/ _jsxs(ButtonContainer, {
        animated: animated || false,
        className: "button-slide-container",
        ref: ref,
        children: [
            !small && defaultButton(),
            small && smallButton()
        ]
    });
});
export default ButtonSlide;
